(() => {
  const progressEl = document.querySelector('[data-box-aktion-progress]');
  if (!progressEl) return;

  const productIds = (progressEl.dataset.productIds || '').split(',').map(id => parseInt(id, 10)).filter(Boolean);
  const goal = parseInt(progressEl.dataset.goal, 10) || 2;
  const discountCode = progressEl.dataset.discountCode || '';
  const msgPre = progressEl.dataset.msgPre || '';
  const msgPost = progressEl.dataset.msgPost || '';
  const fillEl = progressEl.querySelector('[data-box-aktion-fill]');
  const textEl = progressEl.querySelector('[data-box-aktion-text]');

  // Auto-apply discount code once per session
  if (discountCode && !sessionStorage.getItem('box_aktion_discount_applied')) {
    fetch('/checkout?discount=' + encodeURIComponent(discountCode), { method: 'GET' })
      .then(() => {
        sessionStorage.setItem('box_aktion_discount_applied', '1');
      })
      .catch(() => {});
  }

  function updateProgressBar() {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        let boxCount = 0;
        cart.items.forEach(item => {
          if (productIds.includes(item.product_id)) {
            boxCount += item.quantity;
          }
        });

        const pct = Math.min(Math.round((boxCount / goal) * 100), 100);
        fillEl.style.width = pct + '%';

        if (boxCount >= goal) {
          fillEl.classList.add('box-aktion-progress__fill--complete');
          textEl.textContent = msgPost;
        } else {
          fillEl.classList.remove('box-aktion-progress__fill--complete');
          const remaining = goal - boxCount;
          textEl.textContent = msgPre.replace('[x]', remaining);
        }
      })
      .catch(() => {});
  }

  // Subscribe to cart updates with debounce
  let debounceTimer;
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(updateProgressBar, 300);
    });
  }
})();
